"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.SpinnerContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  background: #00000080;
`;
